/**
 * Username/Password Authentication
 */
export interface UsernamePasswordAuthentication {
  username: string;
  password: string;
}

/**
 * ApiKey Authentication
 */
export interface ApiKeyAuthentication {
  apiKey: string;
}

/**
 * ApiSecret Authentication
 */
export interface ApiSecretAuthentication {
  apiSecret: string;
}

/**
 * ApiToken Authentication
 */
export interface ApiTokenAuthentication {
  apiToken: string;
}
